/// <reference path='../_all.ts' />

module blog {
  'use strict';

  export class SalesToolsCtrl {

    public static $inject = [
      '$scope',
      'pageMetaService',
      'blogService',
      'anchorNavService',
      '$mdDialog',
    ];

    constructor(
      private $scope: ISalesToolsCtrlScope,
      private pageMetaService: navigation.IPageMetaService,
      private blogService: IBlogService,
      private anchorNavService: navigation.IAnchorNavService,
      private $mdDialog: ng.material.IDialogService
    ) {
      $scope.vm = this;
      $scope.meta = pageMetaService.getPageMeta;

      $scope.limit = 3;
      $scope.offset = 0;

      $scope.data = { "Verkaufshilfen": [], "Blog": [] };
      this.$scope.selectedTopLevel = {};

      
      var updateNav = () => {
        $scope.topLevelNav = [];
        if ($scope.data.Blog && $scope.data.Blog.length > 0) {
          $scope.topLevelNav.push({ 'id' : 2, 'name' : $scope.meta('hl') == 'D' ? 'Neuigkeiten' : 'News', 'entryType': 'Blog' });
        }
        if ($scope.data.Verkaufshilfen && $scope.data.Verkaufshilfen.length > 0) {
          $scope.topLevelNav.push({ 'id' : 1, 'name' : $scope.meta('hl') == 'D' ? 'Verkaufshilfen' : 'Sales Tools', 'entryType': 'Verkaufshilfen' });
        }
        if ($scope.data.Verkaufshilfen && $scope.data.Verkaufshilfen.length > 0) this.$scope.selectedTopLevel['entryType'] = 'Verkaufshilfen';
        if ($scope.data.Blog && $scope.data.Blog.length > 0) this.$scope.selectedTopLevel['entryType'] = 'Blog'; 
      }

      var getStories = () => {
        blogService.loadByProduct(pglob.RouteData.RouteEntry.RouteParameterStack).then((response) => {
          $scope.data.Blog = response.data.filter((content) => {
            // difference in days
            var diff = this.getTimeDiff(content.ContentMeta.CreatedAt, new Date());
            return content.ContentFilter.FilterString2.toLowerCase() === "blog" 
                     && diff !== undefined && diff < 1825; //fünf jahre
          });
          $scope.data.Verkaufshilfen = response.data.filter((i) => i.ContentFilter.FilterString2.toLowerCase() === "verkaufshilfen");
          updateNav();
        });
      }

      anchorNavService.subscribeOnLocationChanged($scope, (event: ng.IAngularEvent, re: IRouteEntry) => {
        getStories();
        $scope.offset = 0;
      });   

      getStories();

      $scope.$watch("selectedTopLevel", (newVal, oldVal) => {
        if (newVal != oldVal) $scope.offset = 0;
      })

    }

    public getTimeDiff(a, b) {
      var msperday = 1000 * 60 * 60 * 24;

      if (!a || !b) return null;

      if (a instanceof Date) {
        var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
      } else if (a instanceof String) {
        var utc1 = Date.parse(<string>a);
      } else {
        var utc1 = <number>a;
      };

      if (b instanceof Date) {
        var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
      } else if (b instanceof String) {
        var utc2 = Date.parse(<string>b);
      } else {
        var utc2 = <number>b;
      };

      return Math.floor((utc2 - utc1) / msperday);
    }

    public openDialog(ev :  MouseEvent, entry: editor.Content) {
      ev.preventDefault();

      this.$mdDialog.show(<ng.material.IDialogOptions>{
        controller: "blogDetailCtrl",
        templateUrl: 'blog/BlogEntryDetail',
        parent: angular.element(document.body),
        bindToController: true,
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          entry: entry,
          currentLang: this.$scope.meta("hl")
        },
      })
    }

    public getTotalPages(nrofarticles: number): number {
      return Math.ceil(nrofarticles / 3);
    }

    public getCurrentPage(offset: number): number {
      if (!this.$scope.selectedTopLevel) return 0;
      var currentPage = offset / this.$scope.limit + 1;
      this.$scope.isFirstPage = currentPage == 1;
      if (this.$scope.data) {
        this.$scope.isLastPage = this.$scope.offset >= this.$scope.data[this.$scope.selectedTopLevel['entryType']].length - this.$scope.limit;
      }
      return currentPage;
    }

    public nextPage() {
      if (!this.$scope.data || this.$scope.offset >= this.$scope.data[this.$scope.selectedTopLevel['entryType']].length - this.$scope.limit) return;
      var newOffset = this.$scope.offset + this.$scope.limit;
      this.$scope.offset = newOffset;
    }

    public previousPage() {
      if (!this.$scope.data) return;
      var newOffset = this.$scope.offset - this.$scope.limit;
      this.$scope.offset = newOffset;
      if (this.$scope.offset < 0) {
        this.$scope.offset = 0;
        return;
      }
    }

  }
}